<template>
  <div>
    <div v-show="showDepartment" class="row">
      <div class="col-12">
        <div class=" align-items-center mb-2">
          <div class="row">
            <div class="col-9">
              <h4 class="mb-0 ml-75">
                <feather type="layers" class="font-medium-3 mr-1">
                </feather>
                Departments
              </h4>
            </div>
            <div class="col-3">
              <div class="d-flex align-items-center justify-content-end">
                <button type="button"
                        @click="showCreateDepartmentModel = true"
                        class="btn btn-primary btn-sm">
                  <span class="text-nowrap">Create</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CommonTableStore
          :url="url"
          :tableHeaderValues="tableHeaderValues"
          :actions="actions"
          :deleteActions="deleteActions"
          :mutedData="mutedData"
          :storageKey="storageKey"
          :externalTotalRecord="externalTotalRecord"
          :show-per-page="true"
          class="w-100"
      />

      <DepartmentCreateModal :forUpdate="false" @completed="completedAction" :show="showCreateDepartmentModel" @hide="showCreateDepartmentModel = false" />
      <DepartmentCreateModal :forUpdate="true" :data="data" @completed="showUpdateDepartmentModel = false" :show="showUpdateDepartmentModel" @hide="showUpdateDepartmentModel = false" />

    </div>
    <SubDepartment :data="row" @back="back" :show="showDepartment" v-show="!showDepartment" />
  </div>
</template>
<script>
import DepartmentCreateModal from "./DepartmentCreateModal.vue";
import SubDepartment  from "./SubDepartment.vue";
export default {
  components: {
    DepartmentCreateModal,
    SubDepartment
  },
  props: [],
  mounted() {
    localStorage.setItem("url", this.url);
    this.checkDataInStore(this.url)
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
  },
  data() {
    return {
      row:{},
      showDepartment:true,
      data:{},
      force:false,
      updateData:[],
      url: "v1/cms-get-department",
      storageKey: "departmentTab",
      tableHeaderValues: [
        {
          title: "Name",
          valueKey: "name"
        },
      ],
      actions: [
        {
          title: "update",
          cta: (row, index) => {
            this.data = {
              ...row,
              name : row.name,
              id:row._id,
              status: row.status,
              idx: index,
              storageKey: this.storageKey
            }
            this.showUpdateDepartmentModel = true
          }
        },
        {
          title: "Assign Sub Department",
          cta: (row, index) => {
            this.row = {
              ...row,
              idx: index,
              storageKey: this.storageKey
            }
            this.showDepartment = false
          }
        }
      ],
      deleteActions: [
        {
          title: "Delete",
          class: " ml-1 custom-control-primary",
          cta: (row, index) => {
            this.deleteRecord(row);
          }
        }
      ],
      mutedData: [],
      externalTotalRecord: "",
      showCreateDepartmentModel:false,
      showUpdateDepartmentModel:false,
    };
  },
  methods: {
    deleteRecord(row) {
      this.makeRequest("post", "v1/cms-update-department", {
        status: row.status == true ? 1 : 0,
        id: row._id,
      });
    },
    back(){
      this.showDepartment = true
      this.row = {}
      // setTimeout(() => this.completedAction(), 100)
    },
    completedAction(){
      this.$store.dispatch('renderPagination', !this.force);
      this.force = !this.force;
      this.showCreateDepartmentModel = false
      this.showUpdateDepartmentModel = false
    },
  },
}
</script>